import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBMIncjay0sLeb5zsTjjOcIgzro8jdbctw",
    authDomain: "fb-paul.firebaseapp.com",
    databaseURL: "https://fb-paul.firebaseio.com",
    projectId: "fb-paul",
    storageBucket: "fb-paul.appspot.com",
    messagingSenderId: "523148299340",
    appId: "1:523148299340:web:d4c535fc09f9667952b8e9",
    measurementId: "G-W4SN71177V"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export { auth, provider};
  export default db;